export enum RolesType {
  ADMIN = 'ADMIN',
  MANAGEMENT = 'MANAGEMENT',
  REGIONAL_COORDINATOR = 'REGIONAL_COORDINATOR',
  REPRESENTATIVE = 'REPRESENTATIVE',
  SELLER_BYD = 'SELLER_BYD',
  BUSINESS_1 = 'BUSINESS_1',
  BUSINESS_2 = 'BUSINESS_2',
  BACKOFFICE = 'BACKOFFICE',
  PARTNER = 'PARTNER',
  ENGINEERING = 'ENGINEERING',
  INTEGRATOR = 'INTEGRATOR',
  DISTRIBUTOR = 'DISTRIBUTOR',
  END_CLIENT = 'END_CLIENT',
  PCP = 'PCP',
  LOGISTIC = 'LOGISTIC',
  TEMPORARY_ACCESS = 'TEMPORARY_ACCESS',
  ACCESS_DENIED = 'ACCESS_DENIED',
  DEALER = 'DEALER',
  PROVISIONAL_USER = 'PROVISIONAL_USER',
  QUALIFIED_INSTALLER = 'QUALIFIED_INSTALLER',
}
